var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcalCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.33332H15V2.49999C15 2.04166 14.625 1.66666 14.1667 1.66666C13.7083 1.66666 13.3333 2.04166 13.3333 2.49999V3.33332H6.66667V2.49999C6.66667 2.04166 6.29167 1.66666 5.83333 1.66666C5.375 1.66666 5 2.04166 5 2.49999V3.33332H4.16667C3.24167 3.33332 2.50833 4.08332 2.50833 4.99999L2.5 16.6667C2.5 17.5833 3.24167 18.3333 4.16667 18.3333H15.8333C16.75 18.3333 17.5 17.5833 17.5 16.6667V4.99999C17.5 4.08332 16.75 3.33332 15.8333 3.33332ZM15.8333 15.8333C15.8333 16.2917 15.4583 16.6667 15 16.6667H5C4.54167 16.6667 4.16667 16.2917 4.16667 15.8333V7.49999H15.8333V15.8333ZM5.83333 9.16666H7.5V10.8333H5.83333V9.16666ZM9.16667 9.16666H10.8333V10.8333H9.16667V9.16666ZM12.5 9.16666H14.1667V10.8333H12.5V9.16666Z",
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcalCalendar);
export default __webpack_public_path__ + "static/media/ical-calendar.08789e9b.svg";
export { ForwardRef as ReactComponent };